import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { ConfirmRequestCancelButtonCSSStyleImpl } from '../../confirmrequest/confirmrequestcancelbutoncss';

export class SubscriptionFlashMessageComponentCancelButtonCSSStyleImpl extends ConfirmRequestCancelButtonCSSStyleImpl
{
    getButtonStyle(): object 
    {
       return {
        width:'100%',
        height: '40px',
        float: 'left', 
        border:" 1px solid rgba(179,179,179,0.5)",
        borderRadius: '3px',
        overflow: 'hidden',
        backgroundColor:"#FFFFFF",
        cursor: "pointer",
        alignContent: 'center',
        alignItems: "center",
        justifyContent: "center",
        outline:'none'
   
      };
    }

    getButtonText(): object 
    {
        return {
            color: this.getResources().getColor(Colors.color_4), 
            fontSize: this.getResources().getFont(Fonts.h6), 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            fontWeight:'900',

            paddingTop: "5px",
            // width: "118px",
            // textTransform: "uppercase",
            cursor: "pointer"
       };
     } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/flashsubscription/flashsubscriptioncancelbuttoncss.tsx